import { App } from '@ps20-frontend/frontend-models';
import { Vorversicherung } from '@ps20-frontend/shop-integration-redux';
import { StatePreV11, StateV11 } from './11_migrate_vorversicherung.interface';

export const migrateVorversicherung = (
  previousState: StatePreV11,
  newVersion: number,
  _newState: StateV11,
  beibehalten: boolean,
  vorversicherungen: Array<Vorversicherung>,
): StateV11 => {
  return {
    ...previousState,
    version: newVersion,
    hasVorversicherung: vorversicherungen?.find(
      vorversicherung =>
        vorversicherung.appId === App.VWG &&
        vorversicherung.angebotsId === previousState.angebotsId,
    )?.vorhanden,
  };
};
